const {Component} = require("react");
//const InputMask = require("inputmask");
const PropTypes = require("prop-types");
const {pluckKeysExcept} = require("app/util/object");

class Phone extends Component {

	static get propTypes() {
		return {
			onInput: PropTypes.func
		};
	}

	componentDidMount() {
		//(new InputMask("[+99 ]99 99 99 99 [9]", {jitMasking: true, greedy: false})).mask(this.inputElement);
	}

	get name() {
		return this.props.name;
	}

	get value() {
		return this.inputElement.value.replace(/[^+0-9]/g, "");
	}

	_onInput = (e) => {
		let value = this.inputElement.value;
		const withPreffix = value[0] === "+";

		value = value.replace(/[^0-9-]/g, "");
		this.inputElement.value = (withPreffix ? "+" : "") + value;

		if (typeof this.props.onInput === "function") {
			this.props.onInput(e);
		}
	};

	render() {
		const props = pluckKeysExcept(this.props, ["onInput"]);

		return (
			<input ref={el => this.inputElement = el} type="text" pattern="[+]?[\d-]*" onInput={this._onInput} {...props}/>
		);
	}

}

module.exports = Phone;
